module.exports = {
  BASE_URL: "https://api.paribesh.wtlprojects.com/api/v1",
  //BASE_URL: '',
  plog: (v, d = null) => {
    //console.log(v, d);
  },
};